import { create } from "zustand";
import type { BettingPoolStatusResponseDTO } from "@/shared/dto";
import { bettingPoolStatusService } from "@/frontend/services";

interface BettingPoolStatusState {
  statuses: BettingPoolStatusResponseDTO[];
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
  fetchStatuses: () => Promise<void>;
  getStatusById: (id: string) => BettingPoolStatusResponseDTO | undefined;
  getStatusBySlug: (slug: string) => BettingPoolStatusResponseDTO | undefined;
}

export const useBettingPoolStatusStore = create<BettingPoolStatusState>((set, get) => ({
  statuses: [],
  isLoading: false,
  isLoaded: false,
  error: null,

  fetchStatuses: async () => {
    const { isLoading, isLoaded } = get();
    
    if (isLoading || isLoaded) {
      return;
    }

    try {
      set({ isLoading: true, error: null });
      
      const response = await bettingPoolStatusService.getPaginate({ 
        page: 1, 
        pageSize: 100 
      });

      if (response.success && response.data) {
        set({ 
          statuses: response.data.data, 
          isLoaded: true,
          error: null 
        });
      } else {
        set({ 
          error: response.error || "Error al cargar estados",
          isLoaded: false 
        });
      }
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : "Error desconocido",
        isLoaded: false 
      });
    } finally {
      set({ isLoading: false });
    }
  },

  getStatusById: (id: string) => {
    const { statuses } = get();
    return statuses.find((status) => status.id === id);
  },

  getStatusBySlug: (slug: string) => {
    const { statuses } = get();
    return statuses.find((status) => status.slug === slug);
  },
}));
